export default "__VITE_ASSET__Ril2zpA9__"